module.exports = __webpack_public_path__ + "img/nothing.ea32143f.jpg";